<template>
  <div class="column height-100 is-12" :class="{ 'is-paddingless' : detail }">
    <div class="card height-100">
      <header class="header-card">
        <p> {{ $t('societes.indexationCommande.title') }} </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column" :class="{ 'is-4': !detail, 'is-6': detail }">
            <libelle-tag-input
              v-if="!detail"
              v-model="produitsIndexable"
              :items="constantes.CATEGORIE_PRODUIT_INDEXABLE"
              :label="$t('societes.indexationCommande.categorieProduit')">
            </libelle-tag-input>
            <b-field
              v-else
              :label="$t('societes.indexationCommande.categorieProduit')"
              custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ produitsIndexable.map(p => $t(p.libelle)).join(', ') }}
              </span>
            </b-field>
          </div>
          <div class="column" :class="{ 'is-4': !detail, 'is-6': detail }">
            <b-field
              :label="$t('societes.indexationCommande.mantisse')"
              :custom-class="!detail ? '' : 'has-text-weight-normal is-italic is-marginless'">
              <b-input
                v-if="!detail"
                v-model="societe.mantisse"
                type="number">
              </b-input>
              <span v-else class="has-text-weight-bold">
                {{ societe.mantisse }}
              </span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CATEGORIE_PRODUIT_INDEXABLE } from '@/configuration/catalogue/produitConf';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

export default {
  name: 'gestionIndexationCommande',
  props: {
    societe: {
      required: true,
      type: Object,
    },
    detail: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    libelleTagInput,
  },
  data() {
    return {
      constantes: { CATEGORIE_PRODUIT_INDEXABLE },
    };
  },
  computed: {
    produitsIndexable: {
      get() {
        return CATEGORIE_PRODUIT_INDEXABLE
          .filter(c => this.societe.produitsIndexable
            .includes(c.code));
      },
      set(val) {
        this.societe.produitsIndexable = val.map(c => c.code);
      },
    },
  },
};
</script>
